import { useState, useEffect } from "react"
import { Grid, Icon, IconButton } from "@mui/material"
import { useDispatch, useSelector } from "react-redux";
import { Select, Tooltip } from "@gpstrackit/react-controls";
import { useIntl } from "react-intl";
//Components
import { SidePanel, Button, ToggleSwitch } from "@gpstrackit/react-controls";
import CustomSelect from 'Components/Select';

import {
    searchEntityRequest,
    clearRedux,
} from "Redux/actions";

//Actions
import { getAccounts } from 'Modules/activities/views/main/redux/saga';

import { HasPermission } from 'Core/security'

const AdvancedFilters = (props) => {
    const { openPanel, setOpenPanel, tableRef, setAccount, account, keyFobModel, setKeyFobModel } = props;
    const { messages } = useIntl();
    const dispatch = useDispatch();

    //Redux States
    const keyFobModels = useSelector(state => state.generalRedux.keyFobModels);
    const loadingKeyFobModels = useSelector(state => state.generalRedux.loading);
    const loadingKeyFobs = useSelector(state => state.commonRedux.loadingDataView);
    const user = useSelector(state => state.securityRedux.user);

    const { loadingAccounts } = useSelector(state => state.activitiesMainRedux.loadingAccounts)

    //Local States
    const [conditions, setConditions] = useState(tableRef?.current?.conditions || []);

    const handleApply = () => {
        tableRef?.current?.getData({ newConditions: conditions });
    }

    const getAccountsForSelect = (input, callback) => {
        if (!input) {
            callback([])
            return
        }
        getAccounts(input).then((response) => {
            if (response.result) {
                const { items } = response?.result
                callback(items)
            }
        })
    }

    useEffect(() => {
        if (openPanel) {
            (!keyFobModels || (keyFobModels && keyFobModels.length === 0)) && dispatch(searchEntityRequest({ key: "keyFobModels" }));
        }
        if (openPanel) setConditions(tableRef?.current?.conditions || [])
        else setConditions([]);
    }, [openPanel]);

    return (
        <SidePanel
            isOpen={openPanel}
            toggle={() => setOpenPanel(!openPanel)}
            sidePanelButtonStyle={(account || keyFobModel) ? "side-panel-button" : "side-panel-button-white"}
        >
            <Grid
                container
                direction='row'
                justifyContent='space-between'
                alignItems='center'
            >
                <Grid item xs={8}>
                    <label style={{ fontSize: 'large', fontWeight: 500 }}>{messages['accounts_main_advanced_filters']}</label>
                </Grid>
                <Grid item xs={4} style={{ display: 'flex', justifyContent: 'end' }}>
                    <Tooltip title={messages['accounts_main_remove_filters']}>
                        <IconButton
                            onClick={() => {
                                setKeyFobModel(null);
                                setAccount(null);

                                let currentConditions = conditions;

                                let deleteAccount = currentConditions.findIndex((item) => item.fields[0] === 'companyId');
                                deleteAccount >= 0 && currentConditions.splice(deleteAccount, 1);

                                let deleteKeyFobModelId = currentConditions.findIndex((item) => item.fields[0] === 'keyFobModel_id');
                                deleteKeyFobModelId >= 0 && currentConditions.splice(deleteKeyFobModelId, 1);

                                setConditions(currentConditions);

                                tableRef?.current?.getData({ newConditions: currentConditions });

                            }}
                            size="large">
                            <Icon>delete</Icon>
                        </IconButton>
                    </Tooltip>

                </Grid>
                <Grid item xs={12} style={{ marginTop: 10, marginBottom: 10 }}>
                    <Button
                        className="btn btn-dark-blue btn-block"
                        onClick={(e) => {
                            e.preventDefault();
                            handleApply();
                        }}
                        disabled={loadingKeyFobs}
                    >
                        {messages['accounts_main_apply']}
                    </Button>
                </Grid>
                <Grid item xs={12} style={{ textAlign: 'left', marginTop: 10 }}>
                    <CustomSelect
                        async
                        value={account}
                        onChange={(item) => {
                            
                            let currentConditions = conditions;

                            let deleteItem = currentConditions.findIndex((item) => item.fields[0] === 'companyId');
                            deleteItem >= 0 && currentConditions.splice(deleteItem, 1);

                            setAccount(item);
                            if (item) currentConditions.push({ fields: ["companyId"], terms: [item?.id], exact: true, conditionOperator: "AND", account: item })

                            setConditions(currentConditions);
                        }}
                        label={messages['keyfobs_main_account']}
                        loadOptions={getAccountsForSelect}
                        loading={loadingAccounts}
                        getOptionLabel={e => e.name}
                        getOptionValue={e => e.id}
                    />
                </Grid>
                <Grid item xs={12} style={{ textAlign: 'left', marginTop: 10, marginBottom: 5 }}>
                    <Select
                        id="keyfob-model-selector"
                        label={messages['keyfobs_main_keyfob_model']}
                        value={keyFobModels ? keyFobModels.filter((item) => item.id === keyFobModel) : []}
                        onChange={(item = []) => {

                            let currentConditions = conditions;

                            let deleteItem = currentConditions.findIndex((item) => item.fields[0] === 'keyFobModel_id');
                            deleteItem >= 0 && currentConditions.splice(deleteItem, 1);

                            setKeyFobModel(item?.id)
                            if (item) currentConditions.push({ fields: ["keyFobModel_id"], terms: [item?.id], exact: true, conditionOperator: "AND" })

                            setConditions(currentConditions);
                        }}
                        options={keyFobModels}
                        textField="name"
                        valueField="id"
                        loading={loadingKeyFobModels}
                        isClearable
                        placeholder={messages['select']}
                    />
                </Grid>

            </Grid>
        </SidePanel>
    );
}
export default AdvancedFilters